/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { ComboboxOption } from '@headlessui/react'
import clsx from 'clsx'
import { AddressLookupSuggestion } from 'services/googleAddressService'

interface UiLocationSearchOptionsListProps {
    results: AddressLookupSuggestion[]
    query: string
    isLoading: boolean
    translate: (value: string) => string
}

const UiLocationSearchOptionsList = (
    props: UiLocationSearchOptionsListProps
) => {
    if (props.results.length === 0 && props.query !== '' && !props.isLoading) {
        return (
            <div className="UiLocationSearchOptionsList relative cursor-default select-none py-2 px-4 text-gray-700 dark:text-gray-300">
                {props.translate('Nothing found.')}
            </div>
        )
    }

    return (
        <>
            {props.results.map((item, index) => (
                <ComboboxOption
                    key={index}
                    className={({ active }) =>
                        clsx(
                            'relative cursor-default select-none py-2 pl-4 pr-4',
                            active
                                ? 'bg-indigo-600 text-white'
                                : 'text-gray-900 dark:text-gray-100'
                        )
                    }
                    value={item}
                >
                    {({ selected }) => (
                        <div className="flex flex-col">
                            <span
                                className={clsx(
                                    'block truncate',
                                    selected ? 'font-medium' : 'font-normal'
                                )}
                            >
                                {item.description}
                            </span>
                        </div>
                    )}
                </ComboboxOption>
            ))}
        </>
    )
}

export default UiLocationSearchOptionsList
